import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ToggleButton } from './filter-components.styles';
import { getFilteredData, getgraphData } from '../../services/apiservices';
import { pushFilterValue, setLoaders } from '../store/access-graph-slice';
import lowerCase from 'lodash/lowerCase';
import camelCase from 'lodash/camelCase';

const FilterComponent = ({
  emptyToolTip
}) => {
  const [selected, setSelected] = useState('all');
  const policyData = useSelector(state => state.accordionData.policy);
  const dropdownValue = useSelector(state => state.graph.dropdownValue);
  const dispatch = useDispatch();

  const setSelectedValue = event => {
    emptyToolTip();
    const selectedValue = event.target.value;
    dispatch(pushFilterValue(selectedValue));

    switch (selectedValue) {
      case 'all':
        {
          if (selected !== 'all') {
            dispatch(setLoaders(true));
            let url = `/api/ada/graph/accessmap/ramdetailsbyentitytype?entityType=${camelCase(lowerCase(policyData.objectType))}&key=${policyData.entityUuid}`;
            dispatch(getgraphData(url, dropdownValue));
          }

          break;
        }

      case 'Used':
        {
          if (selected !== 'Used') {
            dispatch(setLoaders(true));
            let url = `/api/ada/graph/accessmap/ramdetailsbyentitytype?entityType=${camelCase(lowerCase(policyData.objectType))}&key=${policyData.entityUuid}`;
            dispatch(getFilteredData(url, 'Used', dropdownValue));
          }

          break;
        }

      case 'Un-Used':
        {
          if (selected !== 'Un-Used') {
            dispatch(setLoaders(true));
            let url = `/api/ada/graph/accessmap/ramdetailsbyentitytype?entityType=${camelCase(lowerCase(policyData.objectType))}&key=${policyData.entityUuid}`;
            dispatch(getFilteredData(url, 'Un-Used', dropdownValue));
          }

          break;
        }

      default:
        break;
    }

    setSelected(selectedValue);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "all",
    onClick: setSelectedValue,
    selected: selected === 'all'
  }, "All"), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "Used",
    onClick: setSelectedValue,
    selected: selected === 'Used'
  }, "Used"), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "Un-Used",
    onClick: setSelectedValue,
    selected: selected === 'Un-Used'
  }, "Unused")));
};

export default FilterComponent;